module.exports = __webpack_public_path__ + "static/media/VPN.4316ca17.svg";